import PubSub from "underpub-js";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
import loadTouchEvents from 'jquery-touch-events';
loadTouchEvents($);

var ProjectIndex = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ProjectIndex',
	};

	$.extend(true, this.options, options);

};

ProjectIndex.prototype.init = function() {

	var self = this;

	gsap.registerPlugin(ScrollToPlugin);

	this.$detailPaneColumn = this.options.$el.find(`.${self.options.baseClass}__detailColumn`);
	this.$detailPane = this.options.$el.find(`.${self.options.baseClass}__details`);
	this.$detailPaneImageSlider = this.$detailPane.find(`.${self.options.baseClass}__details__imageSlider`);
	this.$detailPaneTitle = this.$detailPane.find(`.${self.options.baseClass}__details__title`);
	this.$detailPaneTextContent = this.$detailPane.find(`.${self.options.baseClass}__details__textContent`);
	this.$detailPaneCta = this.$detailPane.find(`.${self.options.baseClass}__details__cta .atom-ButtonArrow`);

	this.sliderAutoplayInterval = null;

	this.detailPaneSliderSettings = {
		arrows: false,
		fade: true,
		infinite: true,
		speed: 750,
		swipe: false,
	}

	// initialize image slider
	this.$detailPaneImageSlider.slick( self.detailPaneSliderSettings );

	// previous image button
	this.options.$el.find(`.${self.options.baseClass}__details__previousSlide`).on('click', function() {
		self.restartAutoplay();
		self.previousSlide();
	});

	// next image button
	this.options.$el.find(`.${self.options.baseClass}__details__nextSlide`).on('click', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

	// swipe events
	this.$detailPane.find(`.${self.options.baseClass}__details__imageSliderWrapper`).on('swiperight', function() {
		self.restartAutoplay();
		self.previousSlide();
	});

	this.$detailPane.find(`.${self.options.baseClass}__details__imageSliderWrapper`).on('swipeleft', function() {
		self.restartAutoplay();
		self.nextSlide();
	});

	// start autoplay
	this.restartAutoplay();

	// when a project is clicked
	this.options.$el.find(`.${self.options.baseClass}__index__row`).on('click', function() {
		
		var projectId = $(this).data('projectId');

		self.options.$el.find(`.${self.options.baseClass}__index__row`).removeClass(`${self.options.baseClass}__index__row--active`);

		$(this).addClass(`${self.options.baseClass}__index__row--active`);

		if (window.Breakpoint.value == 'xsmall' || window.Breakpoint.value == 'small')
		{
			gsap.to( $(window), { duration: 0.5, scrollTo: self.options.$el.offset().top } );
		}

		self.updateDetailPane(projectId);

	});

	self.setDetailColumnHeight(); // initing the height prevents the page from jumping when the first project is loaded

	PubSub.subscribe("resized", function() {
		self.setDetailColumnHeight();
	});

};

ProjectIndex.prototype.setDetailColumnHeight = function() {

	var self = this;

	if (window.Breakpoint.value == 'xsmall' || window.Breakpoint.value == 'small')
	{
		gsap.to(self.$detailPaneColumn, { height: self.$detailPane.outerHeight(), duration: 0.4 });
	}
	else
	{
		gsap.set(self.$detailPaneColumn, { height: "auto" });
	}

};

ProjectIndex.prototype.restartAutoplay = function() {

	var self = this;

	clearInterval(self.sliderAutoplayInterval);

	self.sliderAutoplayInterval = window.setInterval(function() {
		self.nextSlide();
	}, 8000);

};

ProjectIndex.prototype.previousSlide = function() {

	this.$detailPaneImageSlider.slick('slickPrev');

};

ProjectIndex.prototype.nextSlide = function() {

	this.$detailPaneImageSlider.slick('slickNext');

};

ProjectIndex.prototype.updateDetailPane = function(projectId) {
	
	var self = this;

	// set the pane to the loading state
	this.$detailPane.addClass(`${self.options.baseClass}__details--loading`);

	var imageUrls = [];
	var title = '';
	var textContent = '';
	var url = '';

	// this data will be populated via graph QL

	var query = `
	query MyQuery {
		entry(section: "projects", id: "` + projectId + `") {
			id
			... on projects_project_Entry {
				id
				slug
				projectHasProjectPage
				title
				projectSummary
				url
				projectFeaturedImages {
					id
					url(transform:"projectIndexImage")
				}
			}
		}
	}

	`;

	// run the ajax query that gets our project data
	$.ajax({

		type: 'POST',
		url: '/api',
		data: { query: query },

		success: function(data) {

			var entry = data.data.entry;

			var imageUrls = [];
			for (var i = 0; i < entry.projectFeaturedImages.length; i++)
			{
				imageUrls.push(entry.projectFeaturedImages[i].url);
			}

			var title = entry.title;;
			var textContent = entry.projectSummary;
			var url = '';

			if (entry.projectHasProjectPage) {
				url = entry.url;
			}

			// populate the pane, if it's active then wait until fade out to populate
			window.setTimeout(function() {
				self.populateDetailPane(imageUrls, title, textContent, url);
			}, 300);

		},

		error: function(data) {
			console.log('ajax error');
			console.log(data);
		},

	});

	/*
	if (projectId == 1)
	{
		var imageUrls = ['/built/images/placeholders/exterior-10.png'];
		var title = '1840 Grant Street';
		var textContent = "<p>Street art crucifix microdosing 90's, wolf yuccie photo booth butcher succulents. Cray kale chips cliche tbh mumblecore disrupt. Chambray twee synth biodiesel bicycle rights kogi pok pok.</p>";
		var url = '#';
	}
	else if (projectId == 2)
	{
		var imageUrls = ['/built/images/placeholders/exterior-2.jpg', '/built/images/placeholders/interior-3.png'];
		var title = 'Trimble II';
		var textContent = "<p>Poutine wayfarers bitters ennui cold-pressed. Forage photo booth meggings intelligentsia affogato, literally offal subway tile cred health goth ethical slow-carb single-origin coffee hoodie austin. Mumblecore VHS chia next level readymade pabst. Kogi edison bulb woke cloud bread chillwave kombucha polaroid bicycle rights.</p>";
		var url = '';
	}
	else if (projectId == 3)
	{
		var imageUrls = ['/built/images/placeholders/exterior-6.png', '/built/images/placeholders/interior-4.png'];
		var title = 'Jalan';
		var textContent = "<p>Humblebrag subway tile affogato gluten-free copper mug raclette glossier williamsburg man bun. Four loko 8-bit tbh, heirloom venmo direct trade hexagon occupy coloring book copper mug jean shorts.</p>";
		var url = '';
	}
	else if (projectId == 4)
	{
		var imageUrls = ['/built/images/placeholders/exterior-8.png', '/built/images/placeholders/exterior-9.png'];
		var title = 'Silverthorne Performing Arts Center';
		var textContent = "<p>Located in the heart of Summit County, Colorado, OZ designed The Silverthorne Performing Arts Center (SPAC) to help fulfill the strategic vision of The Town of Silverthorn in revitalizing their community through a creative and educational space.</p>";
		var url = '#';
	}
	*/

			

		

};

ProjectIndex.prototype.populateDetailPane = function(imageUrls, title, textContent, url) {

	var self = this;

	// clear out the pane
	this.$detailPaneImageSlider.slick('unslick');
	this.$detailPaneImageSlider.html('');
	this.$detailPaneTitle.html('');
	this.$detailPaneTextContent.html('');

	this.$detailPaneCta.parents(`.${self.options.baseClass}__details__cta`).removeClass(`${self.options.baseClass}__details__cta--visible`);

	// populate the panel info
	// add our image slides in
	for (var i = 0; i < imageUrls.length; i++)
	{
		var $imageSlide = `
			<div class="${self.options.baseClass}__details__imageSlider__image" style="background-image: url( '${imageUrls[i]}' );"></div>
		`;
		this.$detailPaneImageSlider.append($imageSlide);
	}
	// reinit the slider and restart autoplay
	this.$detailPaneImageSlider.slick( self.detailPaneSliderSettings );
	this.restartAutoplay();

	this.$detailPaneTitle.html(title);

	if (textContent)
	{
		this.$detailPaneTextContent.html(textContent);
	}

	if (url != '')
	{
		this.$detailPaneCta.parents(`.${self.options.baseClass}__details__cta`).addClass(`${self.options.baseClass}__details__cta--visible`);
		this.$detailPaneCta.attr('href', url);
	}
	else
	{
		this.$detailPaneCta.parents(`.${self.options.baseClass}__details__cta`).removeClass(`${self.options.baseClass}__details__cta--visible`);
	}


	// if our slider is not in use, set a class to disable arrow cursors
	this.options.$el.find(`.${self.options.baseClass}__details__imageSliderWrapper`).removeClass(`${self.options.baseClass}__details__imageSliderWrapper--noSlider`);
	if (imageUrls.length < 2)
	{
		this.options.$el.find(`.${self.options.baseClass}__details__imageSliderWrapper`).addClass(`${self.options.baseClass}__details__imageSliderWrapper--noSlider`);
	}

	

	// remove our loading class once our images are loaded
	if (imageUrls.length > 0)
	{
		// once our first image is loaded
		$('<img/>').attr('src', imageUrls[0]).on('load', function() {
			$(this).remove(); // prevent memory leaks
			self.showDetailPane();
		});
	}
	else
	{
		self.showDetailPane();
	}

};

ProjectIndex.prototype.showDetailPane = function() {

	var self = this;

	self.$detailPane.removeClass(`${self.options.baseClass}__details--loading`);
	
	self.setDetailColumnHeight();

};

export default ProjectIndex;
